import { EmploymentSetupStatus } from '../shared/constants/employmentConstants';
import {
  createEmploymentSchema,
  updateEmploymentEmployeeIdSchema,
  updateEmploymentSchema,
} from '../shared/validations/employerValidations';
import { AddressFields } from './AddressForm';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { LanguagePreferenceField } from './LanguagePreferenceForm.js';
import { useAuth } from '../utils/AuthContext.js';

const EmployeeForm = ({ employerId, employee, onFinish, submitLabel }) => {
  const { api } = useAuth();

  const { employmentId, name, clientEmployeeId, email, phoneNumber, taxId, birthday, address, status } = employee ?? {};

  const handleSubmit = async (values) => {
    if (employmentId) {
      await api.updateEmployeeForEmployer(employerId, employmentId, values);
    } else {
      await api.addEmployeeForEmployer(employerId, values);
    }
  };

  return !status || status === EmploymentSetupStatus.REQUESTED_BY_EMPLOYER ? (
    <ValidatedForm
      key="employee"
      schema={employmentId ? updateEmploymentSchema : createEmploymentSchema}
      initialValues={{ name, clientEmployeeId, email, phoneNumber, taxId, birthday, address }}
      handleSubmit={handleSubmit}
      onFinish={onFinish}
    >
      <FormInput name="name.givenName" type="text" />
      <FormInput name="name.middleName" type="text" />
      <FormInput name="name.familyName" type="text" />
      <FormInput name="clientEmployeeId" type="text" />
      <FormInput name="email" type="email" />
      <FormInput name="phoneNumber" type="text" />
      <FormInput name="taxId" type="text" />
      <FormInput name="birthday" type="date" />
      <LanguagePreferenceField />
      <AddressFields />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  ) : (
    <ValidatedForm
      key="employee"
      schema={updateEmploymentEmployeeIdSchema}
      initialValues={{ clientEmployeeId }}
      handleSubmit={handleSubmit}
      onFinish={onFinish}
    >
      <FormInput name="clientEmployeeId" type="text" />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export default EmployeeForm;
